import {Component, OnDestroy, OnInit} from '@angular/core';
import { environment } from '../../environments/environment';
import {ModalInfoViajeComponent} from "./modal-info-viaje/modal-info-viaje.component";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {ModalTerminarViajeComponent} from "./modal-terminar-viaje/modal-terminar-viaje.component";
import {ApiService} from "../services/api.service";
import {GetListaViajesResponseDTO} from "../../dtos/response/getListaViajes.response.dto";
import {GeneralResponseDTO} from "../../dtos/response/general.response.dto";
import {AppMessage} from "../app.message";
import {ViajeDTO} from "../../dtos/viaje.dto";
import {CommonModule} from "@angular/common";
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import {ViajeService} from "../services/viaje.service";
import {NgSelectModule} from "@ng-select/ng-select";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ProgressbarModule} from "ngx-bootstrap/progressbar";
import moment from "moment";
import 'moment-duration-format';
import {debounceTime, distinctUntilChanged, Observable, skip, Subject, Subscription, timeout} from "rxjs";
import {ModalTerminarViajeTComponent} from "./modal-terminar-viaje-t/modal-terminar-viaje-t.component";
import {ModalInfoViajeTComponent} from "./modal-info-viaje-t/modal-info-viaje-t.component";
import {CambiarSucursalComponent} from "../modals/cambiar-sucursal/cambiar-sucursal.component";
import {EventService} from "../services/event.service";
import {SucursalService} from "../services/sucursal.service";
import {SucursalDTO} from "../../dtos/sucursal.dto";
import {AlertService} from "../services/alert.service";
import {HttpErrorResponse} from "@angular/common/http";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {PdfDTO} from "../../dtos/pdf.dto";
import {ToastrService} from "ngx-toastr";
import {IMqttMessage} from "ngx-mqtt";
import {ConfigMqttService} from "../services/configMqtt.service";
import {GetDetalleViajeResponseDTO} from "../../dtos/response/getDetalleViaje.response.dto";
import {ModalPrintComponent} from "../modals/modal-print/modal-print.component";
import {UserService} from "../services/user.service";


@Component({
  selector: 'app-sinoptico',
  standalone: true,
  imports: [CommonModule,
    InfiniteScrollDirective,
    NgSelectModule,
    ReactiveFormsModule,
    FormsModule,
    ProgressbarModule, TooltipModule
  ],
  templateUrl: './sinoptico.component.html',
  styleUrl: './sinoptico.component.scss'
})
export class SinopticoComponent implements OnInit, OnDestroy {

  public modoEstandar: boolean = true;
  public statusViajeFinalizado = 'FINALIZADO';
  public listaViajes: Array<ViajeDTO> = [];
  private pageSize: number = 50;
  private page: number = 0;
  private hasNext: boolean = false;
  public desactivarInfiniteScroll: boolean = true;
  public searchTxt: string = '';
  private inputValue: Subject<string> = new Subject<string>();
  private inputObservable: Observable<string>;
  private subscriptionSearch: Subscription;
  private sucursalesSub: Subscription;
  public horaActual: string = "";
  private intervalReloj: any;
  private modalViajeTerminado: BsModalRef;
  public sucursalesSelectedNombres: string = '';
  public sucursalesSelectedNombresLargos: string = '';

  public intervaloProgressBar: any;
  public contador: number = 0;
  public recarga = 900000;
  recargas = [
    { label: 'Off', value: 0 },
    { label: '15 minutos', value: 900000 },
  ];
  private listadoSuscripcionesViajesMqtt: {[key: string] : Subscription} = {};
  public servicioSentidoSeleccionado: string[] = [];
  public serviciosSentidos: any[] = [];


  constructor(private modalService: BsModalService, private apiService: ApiService, private viajeService: ViajeService,
              private eventService: EventService, private sucursalService: SucursalService, private alertService: AlertService,
              private toastr: ToastrService, private configMqttService: ConfigMqttService,
              private userService: UserService) {
    this.inputObservable = this.inputValue.pipe(
      debounceTime(600),
      distinctUntilChanged()
    );

    this.subscriptionSearch = this.inputObservable.subscribe(texto => {
      this.searchTxt = texto;
      this.page = 0;
      this.getListaViajes(true);
    });
  }

  ngOnInit(): void {
    this.calcularTime();
    this.sucursalesSelectedNombres = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto();
    this.sucursalesSelectedNombresLargos = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto(true);
    this.initSuscripcionesEventos();
    this.initReloj();
    if(!this.sucursalService.getSucursalesSeleccionadas() || this.sucursalService.getSucursalesSeleccionadas().length == 0) {
      //alert('Debe seleccionar alguna sucursal');
      this.toastr.warning('Debe seleccionar alguna sucursal', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }
    this.initAllDatosWS();
    this.cargarServiciosSentidos();
  }

  reload(){
    this.calcularTime();
    this.initAllDatosWS();
  }

  initSuscripcionesEventos() {
    this.eventService.subscribe('VIAJE_FINALIZADO_SUCCESS', () => {
      this.initAllDatosWS();
      this.modalViajeTerminado.hide();
      setTimeout(() => {
        this.showModalViajeTerminado();
      }, 300)
    })

    this.sucursalesSub = this.sucursalService.sucursales$.pipe(skip(1)).subscribe(() => {
      this.sucursalesSelectedNombres = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto();
      this.sucursalesSelectedNombresLargos = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto(true);
      this.initAllDatosWS();
    })
  }

  initReloj() {
    this.horaActual = moment().format("HH:mm:ss");
    this.intervalReloj = setInterval(() => { this.horaActual = moment().format("HH:mm:ss"); }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.intervaloProgressBar);
    clearInterval(this.intervalReloj);
    if(this.subscriptionSearch)
      this.subscriptionSearch.unsubscribe();
    this.sucursalesSub?.unsubscribe();

    this.unsubscribeMqtt();
  }

  openModalCambiarSucursal() {
    this.modalService.show(CambiarSucursalComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-md'
    });
  }

  tienePermisoVerDetalle(): boolean {
    return this.userService.tienePermiso('SINOPTICO_VER_DETALLE');
  }

  tienePermisoFinalizarViaje(): boolean {
    return this.userService.tienePermiso('VIAJE_FINALIZAR');
  }

  tienePermisoImprimirPlanilla(): boolean {
    return this.userService.tienePermiso('VOUCHER_COLACION') || this.userService.tienePermiso('VOUCHER_RUTA_VIAJE');
  }

  verViaje(viaje: ViajeDTO) {
    this.viajeService.setViajeSeleccionado(viaje);
    let modalComponent: any = ModalInfoViajeComponent;
    //let modalComponent: any = ModalInfoViajeTComponent;
    if(viaje.estado == this.statusViajeFinalizado)
      modalComponent = ModalInfoViajeTComponent;

    this.modalService.show(modalComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xl'
    });
  }

  terminarViaje(viaje: ViajeDTO) {
    this.viajeService.setViajeSeleccionado(viaje);
    this.modalViajeTerminado = this.modalService.show(ModalTerminarViajeComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-md'
    });
  }

  showModalViajeTerminado() {
    this.modalViajeTerminado = this.modalService.show(ModalTerminarViajeTComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-md'
    });
  }

  calcularTime() {
    clearInterval(this.intervaloProgressBar);
    if (this.recarga != 0)
      this.initProgressBar();
  }

  initProgressBar() {
    this.contador = this.recarga;
    this.intervaloProgressBar = setInterval(() => {
      this.contador -= 1000;
      if(this.contador < 0) {
        this.initAllDatosWS();
        this.contador = this.recarga;
      }
    }, 1000);
  }


  muestraHora(fecha: string) {
    if(!fecha)
      return '';
    return moment.utc(fecha).local().format('HH:mm');
  }

  muestraDiferenciaMinutos(fechaInicial: string, fechaSalida: string) {
    if(!fechaInicial || !fechaSalida)
      return'';

    const fecha2 = moment.utc(fechaSalida);
    const fecha1 = moment.utc(fechaInicial);
    if(fecha2 > fecha1)
      return '+' + fecha2.diff(fecha1, 'minutes') + 'm';
    else
      return fecha2.diff(fecha1, 'minutes') + 'm';
  }

  muestraDiferenciaHorasMinutos(fechaTermino: string, fechaLlegada: string) {
    if(!fechaTermino)
      return'';

    if(fechaLlegada)
      return this.muestraDiferenciaViajeTerminado(fechaTermino, fechaLlegada);

    const fecha2 = moment.utc(fechaTermino);
    const fecha1 = moment().utc();
    let diferencia = 0;
    if(fecha2 >= fecha1) {
      diferencia = fecha2.diff(fecha1);
      return moment.duration(diferencia).format('HH:mm');
    }else {
      diferencia = fecha1.diff(fecha2);
      return '+' + moment.duration(diferencia).format('HH:mm');
    }
  }

  muestraDiferenciaViajeTerminado(fechaTermino: string, fechaLlegada: string) {
    const fecha2 = moment.utc(fechaTermino);
    const fecha1 = moment.utc(fechaLlegada);
    let diferencia = 0;
    if(fecha2 >= fecha1) {
      diferencia = fecha2.diff(fecha1);
      return moment.duration(diferencia).format('HH:mm');
    }else {
      diferencia = fecha1.diff(fecha2);
      return '+' + moment.duration(diferencia).format('HH:mm');
    }
  }

  initAllDatosWS() {
    this.getListaViajes(true);
  }

  onInput(e: any) {
    this.inputValue.next(e.target.value);
  }


  getListaViajes(init: boolean = false) {
    if (init)
      this.page = 0;

    const serviciosSentidos = this.servicioSentidoSeleccionado && this.servicioSentidoSeleccionado.length > 0
      ? this.servicioSentidoSeleccionado.join(',')
      : '';

    this.apiService.getListaViajes(this.page, this.pageSize, this.searchTxt, this.sucursalService.getSucursalesUUIDSeleccionadasComoTexto(), serviciosSentidos).subscribe((resp) => this.getListaViajesSuccess(resp, init), (error) => this.getListaViajesError(error));
  }

  getListaViajesSuccess(getListaViajesResponseDTO: GetListaViajesResponseDTO, init: boolean) {
    console.log('exito lista viajes', getListaViajesResponseDTO);
    if(init)
      this.listaViajes = getListaViajesResponseDTO.data.list;
    else
      this.listaViajes = this.listaViajes.concat(getListaViajesResponseDTO.data.list);

    this.hasNext = getListaViajesResponseDTO.data.hasNext;
    this.initSuscripcionesMqtt();
    if(this.hasNext) {
      this.desactivarInfiniteScroll = false;
      this.page++;
      return;
    }

    this.desactivarInfiniteScroll = true;
  }

  getListaViajesError(error: HttpErrorResponse) {
    console.log('error lista viajes', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_LISTA_VIAJES_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  initSuscripcionesMqtt() {
    console.log('init suscripicon mqtt');
    this.listaViajes.forEach((viaje) => {
      if(!this.listadoSuscripcionesViajesMqtt[viaje.uuid]) {
        this.listadoSuscripcionesViajesMqtt[viaje.uuid] = this.configMqttService.subscribeTopicViajes(viaje.uuid).subscribe((mqttMessage: IMqttMessage) => {
          const json = JSON.parse(mqttMessage.payload.toString());
          //console.log('message mqtt', json.uuid); //
          const indice = this.listaViajes.findIndex(viaje => (viaje.uuid === json.uuid) && (viaje.version < json.version));
          if(indice !== -1)
            this.getDetalleViaje(viaje.uuid);
        });
      }
    })
  }

  unsubscribeMqtt() {
    for (let uuid in this.listadoSuscripcionesViajesMqtt) {
      if(this.listadoSuscripcionesViajesMqtt[uuid])
        this.listadoSuscripcionesViajesMqtt[uuid].unsubscribe();
    }
  }

  getDetalleViaje(uuidViaje: string) {
    this.apiService.getDetalleViaje(uuidViaje).subscribe((resp) => this.getDetalleViajeSuccess(resp), (error) => this.getDetalleViajeError(error));
  }

  getDetalleViajeSuccess(getDetalleViajeResponseDTO: GetDetalleViajeResponseDTO) {
    console.log('exito detalle viaje', getDetalleViajeResponseDTO);
    if(getDetalleViajeResponseDTO.data) {
      const indice = this.listaViajes.findIndex(viaje => viaje.uuid === getDetalleViajeResponseDTO.data.uuid);
      if(indice !== -1) {
        this.listaViajes[indice] = getDetalleViajeResponseDTO.data;
        this.eventService.publish('VIAJE_ACTUALIZADO_MQTT_EVENT', getDetalleViajeResponseDTO.data);
      }
    }
  }

  getDetalleViajeError(error: HttpErrorResponse) {
    console.log('error detalle viaje', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_DETALLE_VIAJE_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }


  onScroll() {
    if(this.hasNext)
      this.getListaViajes();
  }

  muestraModalImprimirColacionRutaViaje(viaje: ViajeDTO) {
    this.modalService.show(ModalPrintComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs',
      initialState: {
        viaje: viaje,
        from: 'sinoptico',
        conductor: viaje.conductor
      }
    });
  }

  /*getRutaViajePDF(viaje: ViajeDTO) {
    this.apiService.getRutaViajePDF(viaje.uuid)
      .subscribe((resp) => this.getRutaViajePDFSuccess(resp), (error) => this.getRutaViajePDFError(error));
  }

  getRutaViajePDFSuccess(pdfDTO: PdfDTO) {
    console.log('exito pdf');
    if(pdfDTO.base64Content)
      pdfDTO.generatePdfFromBase64();
    else
      this.toastr.success(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`, 'Éxito', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
  }

  getRutaViajePDFError(error: HttpErrorResponse) {
    console.log('error kpis', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PDF_WS;
    //alert(msg);
    this.alertService.presentAlertaError(msg, error);
  }*/

  cargarServiciosSentidos(): void {
    this.apiService.getServiciosSentidos().subscribe({
      next: (response) => {
        if (response.success) {
          this.serviciosSentidos = response.data.map((item: any) => ({
            value: `${item.serviceName}-${item.sentido}`,
            label: `${item.serviceName} - ${item.sentido}`
          }));
        }
      },
      error: (error) => {
        console.error('Error al cargar servicios-sentidos:', error);
        this.toastr.error((error?.error?.msg || 'Error al cargar servicios') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
      }
    });
  }

  onServicioSentidoChange(): void {
    this.getListaViajes(true);
  }

  getServiciosSentidosSeleccionados(): string {
    if (!this.servicioSentidoSeleccionado || this.servicioSentidoSeleccionado.length === 0) {
      return '';
    }

    if (this.servicioSentidoSeleccionado.length === 1) {
      const selected = this.serviciosSentidos.find(s => s.value === this.servicioSentidoSeleccionado[0]);
      return selected ? selected.label : '';
    }

    return `${this.servicioSentidoSeleccionado.length} seleccionados`;
  }

}
